import { useQuery } from "@tanstack/react-query";
import { fetchInventoryAnalysis, type InventoryAnalysisParams } from "../services/invAnalysisService";

export const useInventoryAnalysis = (params: InventoryAnalysisParams = {}) => {
  return useQuery({
    queryKey: ["inventory_analysis", params],
    queryFn: () => fetchInventoryAnalysis(params),
    staleTime: 1000 * 60 * 5, // cache for 5 mins
  });
};
